//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('contentSourceBadgeAvatar', {
    template: require('@legacy-components/common/content-source-badge/content-source-badge-avatar.html'),
    bindings: {
      avatarUrl: '<',
      sourceIcon: '<',
      emailHash: '<',
      titleFirstLetter: '<',
      sourceType: '<',
    },
    controller: [
      'ContentSourceTypes',
      function(
                ContentSourceTypes,
            ) {
        const self = this;

        self.SOURCE_TYPE_UPLOAD = ContentSourceTypes.UPLOAD;
      },
    ],
  });
})();
